import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Input,
  Form
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Select from "react-dropdown-select";
import { Spinner } from 'reactstrap';
function ManageDriver() {
  const { id } = useParams();
  const [user, setUser] = useState({
    Id: 0,
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    Password: "",
    RoleId: 2,
    StoreId: "",
    StoreName: "",
    storeDataValue: []
  });

  const [roles, setRoles] = useState([]);
  const [newStoreData, setnewStoreData] = useState([])
  const history = useHistory();
  const [IsLoading, setIsLoading] = useState(false)
  const { register, errors, handleSubmit } = useForm()
  useEffect(() => {
    getRoles();
    if (id) {
      loadDriver();
    }
  }, []);


  const getRoles = () => {
    var response = callAPI(`/api/roles`, "GET", null);
    response.then((res) => {
      if (res.success) {
        setRoles({ roles: res.data });
      }
    });
  };
console.log(id);
  const formRef = useRef(null)
  const loadDriver = () => {
    let newdata = []
    var response = callAPI(`/api/drivers/${id}`, "GET", null);
    response.then((res) => {
    console.log(res.data);
      if (res.success) {
        setUser({
          ...res.data[0],
          storeDataValue: [{
            ["label"]: res.data[0].StoreName,
            ["value"]: res.data[0].StoreId
          }]
        })
      } else {
        toast.error(res.message);
      }
    });
  };


  let renderRoleOptions =
    roles.length > 0 || roles.roles != undefined
      ? roles.roles.map((role) => {
        return (
          <option key={role.Id} value={role.Id}>
            {role.RoleName}
          </option>
        );
      })
      : "";

  const onInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };
  const onSubmit = () => {
    if (user.storeDataValue.length == 0) {
      toast.error("Please Select Store");
    }
    else {
      setIsLoading(true)
      var response = callAPI(`/api/drivers`, "POST", JSON.stringify(user));
      response.then((res) => {
        if (res.success) {
          toast.success("User saved!!!");
          setTimeout(() => {
            setIsLoading(false)
            history.push("/admin/driver");
          }, 1000);
        } else {
          setIsLoading(false)
          toast.error(res.message);
        }
      });
    }

  }
  const handleClick = (e) => {
    e.preventDefault();
    formRef.current.props.onSubmit()
  };

  // dropdown store data
  let addData = []
  useEffect(() => {
    var response = callAPI(`/api/stores`, "GET", null);
    response.then((res) => {
      if (res.success) {
        res.data.map(el => {

          addData.push({
            ["label"]: el.StoreName,
            ["value"]: el.Id
          })
        })
        setnewStoreData(addData)
      } else {
        toast.error(res.message);
      }
    });
  }, [])


  const onStoreChange = (value) => {
    value.map(el => {
      setUser({
        ...user,
        StoreId: el.value,
        StoreName: el.label,
        storeDataValue: [{
          ["label"]: el.label,
          ["value"]: el.value
        }]
      })
    })

  }

  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>
      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                <CardTitle tag="h4">Driver Management</CardTitle>
              </CardHeader>
              <CardBody>
                <Form id="add_user" ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                  <div className="new_user">
                    <input type="hidden" name="Id" value={user.Id} />
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="fname" className="text-dark">
                            First Name:
                          </label>
                          <Input
                            type="text"
                            name="FirstName"
                            value={user.FirstName}
                            className="form-control"
                            placeholder="John"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.FirstName && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="lname" className="text-dark">
                            Last Name:
                          </label>
                          <Input
                            type="text"
                            name="LastName"
                            value={user.LastName}
                            className="form-control"
                            placeholder="Mark"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.LastName && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="EmailAddress" className="text-dark">
                            Email Address:
                          </label>
                          <Input
                            type="email"
                            name="EmailAddress"
                            value={user.EmailAddress}
                            className="form-control"
                            placeholder="john@gmail.com"
                            onChange={(e) => onInputChange(e)}
                            disabled={user.Id > 0 ? true : false}
                            innerRef={register({ required: true })}
                            invalid={errors.EmailAddress && true}
                          />
                        </div>
                      </Col>
                      {user.Id > 0 ? (
                        ""
                      ) : (
                        <Col xs={12} md={6}>
                          <div className="form-group">
                            <label for="password" className="text-dark">
                              Password:
                            </label>
                            <Input
                              type="password"
                              name="Password"
                              value={user.Password}
                              className="form-control"
                              placeholder="*********"
                              onChange={(e) => onInputChange(e)}
                              innerRef={register({ required: true })}
                              invalid={errors.Password && true}
                            />
                          </div>
                        </Col>
                      )}
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="RoleId" className="text-dark">
                            Role:
                          </label>
                          <Input
                            type="select"
                            name="RoleId"
                            className="form-control"
                            value={user.RoleId}
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.RoleId && true}
                          >
                            <option value="">Select Role</option>
                            { }
                            {renderRoleOptions}
                          </Input>
                        </div>
                      </Col>
                      {
                        (localStorage.getItem("roleid") == 1 || localStorage.getItem("roleid") == 3) &&
                        <Col xs={12} md={6}>
                          <div className="form-group">
                            <label for="storename" className="text-dark">
                              Store Name:
                            </label>
                            <Select
                              name="StoreName"
                              options={newStoreData}
                              values={user.storeDataValue}
                              className="bg-white rounded store-dropdown"
                              placeholder="Search Store.."
                              innerRef={register({ required: true })}
                              invalid={errors.StoreName && true}
                              onChange={(value) => onStoreChange(value)}
                            />
                          </div>
                        </Col>

                      }

                    </Row>
                    <div className="form-group">
                      <Button
                        type="submit"
                        onClick={(e) => handleClick(e)}
                        className="btn btn-info"
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ManageDriver;
